import { Formik, Form, Field, FieldArray } from 'formik';
import { getImages, teamImages } from '../../Common/const';
import { useContext, useRef, useState, useEffect } from 'react';
import { VehicleContext } from '../../Context/VehicleContext';

const locations = ['Austin', 'Boerne'];
const departments = ['Leadership', 'Sales', 'Service', 'Operations', 'Accounting & Titling', 'Detailing', 'Mark Customs'];

const ManageTeamItem = ({ }) => {

    const {getTeamMembers,teamMembersModify,uploadDocument} = useContext(VehicleContext);

    const submitButtonRef = useRef(null);

    const getTeamImage = (member) => {
        if (member.photo_url instanceof File) {
            return URL.createObjectURL(member.photo_url);
        }
    
        try {
            const fileName = `${member.full_name?.replace(/\s+/g, '-')}.png`;
            return teamImages(`./${fileName}`);
        } catch (err) {
            console.warn('Image not found, showing fallback');
            return teamImages('./no-photo.png');
        }
    };

    // Search functionality
    const [searchTerm, setSearchTerm] = useState('');

    const [teamMembers, setTeamMembers] = useState([]);

    const handleInputChange = (input_id, field, value) => {

        setTeamMembers(prevItems =>
            prevItems.map(item =>
                item.id === input_id ? { ...item, [field]: value } : item
            )
        );
    };

    const addTeamMember = async () => {
        const data = await teamMembersModify({'action':'add_team_member'});

        if(data) setTeamMembers(data);
    }

    const removeTeamMember = (input_id) => {
        teamMembersModify({'action':'remove_team_member','id':input_id});

        setTeamMembers(prevItems =>
            prevItems.filter(item => item.id != input_id)
        );
    }

    const updateTeamMember = async (input_id,field,value) => {
        console.log(input_id,field,value);
        const data = await teamMembersModify({'action':'update_team_member','id':input_id,'field':field,'value':value});

        if(field == "photo_key" && data) setTeamMembers(data);
    }
    
    const fetchTeamMembers = async () => {
        const data = await getTeamMembers();

        console.log(data);
    
        setTeamMembers(data);
    }
      
    useEffect(() => {
        fetchTeamMembers();
    },[]);

    const handleImageChange = (event,input_id) => {
        uploadFiles(event.target.files,input_id);
    };

    const uploadFiles = (files,input_id) => {
        Array.from(files).map((v,i) => {
            uploadFile(v,input_id);
        });
    }

    const uploadFile = (file,input_id) => {
        console.log(file);

        if (file) {

            console.log(file);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('folder', 'teammembers/');
            formData.append('fileName',file.name);
            //formData.append('base_url',true);

            const upload = uploadDocument(formData);
            upload.then((data) => {
                if (data.url && data.data && data.data.key) {
                    //sendChat("",activeChatUser,data.data.key,data.url);

                    console.log(data.url);

                    updateTeamMember(input_id, 'photo_key', data.data.key);
                    
                } else if(data.error) alert(data.error);
            });
        }
            
    }
    
    return (
        <>

                        <div className='d-flex align-items-center justify-content-between mb-5'>
                            <div className='md-title font-1-8em text-uppercase'>Manage Team</div>
                            <div className='d-flex align-items-center'>
                                <button
                                    type='button'
                                    className='theme-sm-btn ad-md-btn text-uppercase me-4'
                                    onClick={() =>
                                        { 
                                            addTeamMember();
                                            setTimeout(() => {
                                                submitButtonRef.current?.scrollIntoView({ behavior: 'smooth' });
                                            }, 100);
                                        }
                                    }
                                >
                                    <img src={getImages('admin/plus-icon.svg')} alt="add" /> Add Employee
                                </button>
                                <div className='ad-search-block d-flex align-items-center'>
                                    <input
                                        type='text'
                                        className='form-control'
                                        placeholder='Search'
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                    <button className='ad-search-btn'>Search</button>
                                </div>
                            </div>
                        </div>

                        {teamMembers && teamMembers.filter((member,index) => {
                                const search = searchTerm.toLowerCase();
                                return !search || (
                                    member.full_name?.toLowerCase().includes(search) ||
                                    member.position?.toLowerCase().includes(search) ||
                                    member.location?.toLowerCase().includes(search) ||
                                    member.department?.toLowerCase().includes(search)
                                );
                            })
                            .map((member,index) => (
                                <form className='custom-form ad-custom-form' key={index}>
                                    <div className='ad-team-item'>
                                        <div className='row align-items-center'>
                                            <div className='col-md-2'>
                                                <div className='ad-team-circle'>
                                                    <img src={member.photo_url ? member.photo_url : teamImages('./no-photo.png')} alt={member.full_name} key={"team_photo"+member.id}/>
                                                </div>
                                                <div className='text-center mt-3'>
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        style={{ display: 'none' }}
                                                        id={`photo-upload-${index}`}
                                                        onChange={(e) => handleImageChange(e,member.id)}
                                                    />
                                                    <button
                                                        type='button'
                                                        className='ad-upload-photo'
                                                        onClick={() => {
                                                        document.getElementById(`photo-upload-${index}`).click();
                                                        }}
                                                    >
                                                        Upload Photo
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='col-md-8'>
                                                <div className='row'>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className='cs-label'>Full Name</div>
                                                        <input name={`team[${index}].full_name`} className='form-control' value={member.full_name || ""}
                                                            onChange={(e) => {handleInputChange(member.id, 'full_name', e.target.value)}}
                                                            onBlur={(e) => {updateTeamMember(member.id, 'full_name', e.target.value)}}
                                                        />
                                                    </div>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className='cs-label'>Position</div>
                                                        <input name={`team[${index}].position`} className='form-control' value={member.position || ""}
                                                            onChange={(e) => {handleInputChange(member.id, 'position', e.target.value)}}
                                                            onBlur={(e) => {updateTeamMember(member.id, 'position', e.target.value)}}
                                                        />
                                                    </div>
                                                    <div className='col-md-4 mb-3'>
                                                        <div className='cs-label'>Phone</div>
                                                        <input name={`team[${index}].phone`} className='form-control' value={member.phone || ""}
                                                            onChange={(e) => {handleInputChange(member.id, 'phone', e.target.value)}}
                                                            onBlur={(e) => {updateTeamMember(member.id, 'phone', e.target.value)}}
                                                        />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='cs-label'>Email</div>
                                                        <input name={`team[${index}].email`} className='form-control' value={member.email || ""}
                                                            onChange={(e) => {handleInputChange(member.id, 'email', e.target.value)}}
                                                            onBlur={(e) => {updateTeamMember(member.id, 'email', e.target.value)}}
                                                        />
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='cs-label'>Location</div>
                                                        <select name={`team[${index}].location`} className='form-control' value={member.location || ""}
                                                            onChange={(e) => {handleInputChange(member.id, 'location', e.target.value); updateTeamMember(member.id, 'location', e.target.value);}}
                                                        
                                                        >
                                                            <option value="">Select Location</option>
                                                            {locations.map(loc => <option key={loc} value={loc}>{loc}</option>)}
                                                        </select>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className='cs-label'>Department</div>
                                                        <select name={`team[${index}].department`} className='form-control' value={member.department || ""}
                                                            onChange={(e) => {handleInputChange(member.id, 'department', e.target.value); updateTeamMember(member.id, 'department', e.target.value);}}
                                                        >
                                                            <option value="">Select Department</option>
                                                            {departments.map(dep => <option key={dep} value={dep}>{dep}</option>)}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-2 text-center'>
                                                <button
                                                    type="button"
                                                    className="ad-trans-btn xs-title fw-400 font-15"
                                                    onClick={() => removeTeamMember(member.id)}
                                                >
                                                    <img className="mb-1 me-0" src={getImages('admin/trash-icon.svg')} alt="delete" />
                                                    <div>Delete</div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                            </form>
                        ))}

                        <div className='mt-4 text-center' ref={submitButtonRef}>
                            {/* <button type="submit" className="theme-sm-btn text-uppercase mnw-150">
                                Save Team
                            </button> */}
                        </div>
        </>
    )
}

export default ManageTeamItem